// Product catalogue data with clinical details and literature.
// Note: dosage and indications shown are typical prescribing summaries;
// actual prescribing information should reference the printed literature.

export const products = [
  {
    name: "ADMAWEL",
    generic: "Amlodipine + Valsartan",
    division: "Human health",
    mark: "H",
    form: "Film-coated tablet",
    composition: "Amlodipine 5 mg + Valsartan 80 mg",
    indications: "Hypertension in adults not adequately controlled on monotherapy.",
    dosage: "One tablet once daily, preferably at the same time each day.",
    literature: "ADMAWEL — Combination Antihypertensive Therapy",
  },
  {
    name: "ALTIXUM",
    generic: "Piracetam",
    division: "Human health",
    mark: "A",
    form: "Tablet / Oral solution",
    composition: "Piracetam 800 mg",
    indications: "Adjunctive treatment of cortical myoclonus and cognitive disorders.",
    dosage: "7.2 g daily in 2–3 divided doses, titrated as needed.",
    literature: "ALTIXUM — Cognitive & Neurological Support",
  },
  {
    name: "ATROW",
    generic: "Atorvastatin",
    division: "Human health",
    mark: "A",
    form: "Film-coated tablet",
    composition: "Atorvastatin 10 / 20 / 40 mg",
    indications: "Primary hypercholesterolaemia and mixed dyslipidaemia.",
    dosage: "10–80 mg once daily; adjust every 4 weeks.",
    literature: "ATROW — Lipid Management Portfolio",
  },
  {
    name: "AZIROMYCIN",
    generic: "Azithromycin",
    division: "Human health",
    mark: "A",
    form: "Tablet / Dry suspension",
    composition: "Azithromycin 250 / 500 mg",
    indications: "Respiratory, skin and soft tissue infections due to susceptible organisms.",
    dosage: "500 mg once daily for 3 days, or as directed.",
    literature: "AZIROMYCIN — Macrolide Antibiotic Range",
  },
  {
    name: "BIXREX",
    generic: "Phloroglucinol",
    division: "Human health",
    mark: "B",
    form: "Tablet / Injection",
    composition: "Phloroglucinol 80 mg",
    indications: "Symptomatic treatment of smooth muscle spasm in GI and urinary tract.",
    dosage: "1–2 tablets 2–3 times daily during painful episodes.",
    literature: "BIXREX — Antispasmodic Reference",
  },
  {
    name: "CAMROID",
    generic: "Piroxicam",
    division: "Human health",
    mark: "C",
    form: "Capsule / Injection",
    composition: "Piroxicam 20 mg",
    indications: "Symptomatic relief of osteoarthritis, rheumatoid arthritis, acute musculoskeletal pain.",
    dosage: "20 mg once daily with food.",
    literature: "CAMROID — NSAID Pain Management",
  },
  {
    name: "CANER",
    generic: "Meloxicam",
    division: "Human health",
    mark: "C",
    form: "Tablet",
    composition: "Meloxicam 7.5 / 15 mg",
    indications: "Osteoarthritis, rheumatoid arthritis and ankylosing spondylitis.",
    dosage: "7.5 mg once daily; up to 15 mg if needed.",
    literature: "CANER — Selective NSAID",
  },
  {
    name: "CEFTRIX",
    generic: "Ceftriaxone",
    division: "Human health",
    mark: "C",
    form: "Powder for injection",
    composition: "Ceftriaxone sodium 250 / 500 / 1000 mg",
    indications: "Serious infections including septicaemia, meningitis and pneumonia.",
    dosage: "1–2 g IV/IM once daily; adjust per infection severity.",
    literature: "CEFTRIX — Third-generation Cephalosporin",
  },
  {
    name: "CIPRA",
    generic: "Ciprofloxacin",
    division: "Human health",
    mark: "C",
    form: "Tablet / Infusion",
    composition: "Ciprofloxacin 250 / 500 mg",
    indications: "Urinary tract, respiratory and gastrointestinal infections.",
    dosage: "500 mg twice daily for 7–14 days.",
    literature: "CIPRA — Fluoroquinolone Antibiotic",
  },
  {
    name: "DIBAVAC",
    generic: "Glimepiride",
    division: "Human health",
    mark: "D",
    form: "Tablet",
    composition: "Glimepiride 1 / 2 / 4 mg",
    indications: "Type 2 diabetes mellitus when diet and exercise are insufficient.",
    dosage: "Initial 1 mg once daily, titrate weekly per glycaemic response.",
    literature: "DIBAVAC — Oral Antidiabetic",
  },
  {
    name: "DIFUNOL",
    generic: "Fluconazole",
    division: "Human health",
    mark: "D",
    form: "Capsule / IV solution",
    composition: "Fluconazole 50 / 150 / 200 mg",
    indications: "Systemic candidiasis, cryptococcosis and dermatophyte infections.",
    dosage: "150 mg single dose or 50–400 mg daily per indication.",
    literature: "DIFUNOL — Antifungal Reference",
  },
  {
    name: "IROWAN",
    generic: "Iron Polymaltose",
    division: "Human health",
    mark: "I",
    form: "Syrup / Chewable tablet",
    composition: "Iron (III) hydroxide polymaltose complex 100 mg elemental iron",
    indications: "Iron deficiency and iron deficiency anaemia.",
    dosage: "1–3 tablets or 10–30 mL syrup daily in divided doses.",
    literature: "IROWAN — Haematinic Portfolio",
  },
  {
    name: "LACPRIL",
    generic: "Pregabalin",
    division: "Human health",
    mark: "L",
    form: "Capsule",
    composition: "Pregabalin 50 / 75 / 150 mg",
    indications: "Neuropathic pain, partial-onset seizures and generalised anxiety disorder.",
    dosage: "150 mg/day in 2–3 divided doses; titrate to 300–600 mg/day.",
    literature: "LACPRIL — Neuropathic Pain Manager",
  },
  {
    name: "NOLCER",
    generic: "Esomeprazole",
    division: "Human health",
    mark: "N",
    form: "Enteric-coated tablet",
    composition: "Esomeprazole 20 / 40 mg",
    indications: "GERD, erosive oesophagitis and Zollinger–Ellison syndrome.",
    dosage: "20–40 mg once daily before breakfast.",
    literature: "NOLCER — PPI Therapy Line",
  },
  {
    name: "ROZWAN",
    generic: "Rosuvastatin",
    division: "Human health",
    mark: "R",
    form: "Film-coated tablet",
    composition: "Rosuvastatin 5 / 10 / 20 mg",
    indications: "Primary hypercholesterolaemia and mixed dyslipidaemia.",
    dosage: "10 mg once daily; adjust every 4 weeks up to 40 mg.",
    literature: "ROZWAN — Advanced Statin Therapy",
  },
  {
    name: "SARTIWAN",
    generic: "Losartan Potassium",
    division: "Human health",
    mark: "S",
    form: "Film-coated tablet",
    composition: "Losartan potassium 50 / 100 mg",
    indications: "Essential hypertension and diabetic nephropathy.",
    dosage: "50 mg once daily; may increase to 100 mg.",
    literature: "SARTIWAN — Angiotensin-II Antagonist",
  },
  {
    name: "ADE-MAX",
    generic: "Vitamin A, D3 & E",
    division: "Livestock",
    mark: "A",
    form: "Oral solution",
    composition: "Vitamin A 500,000 IU + D3 100,000 IU + E 100 mg per mL",
    indications: "Prevention and treatment of vitamin A, D3 and E deficiencies in cattle and sheep.",
    dosage: "1 mL per 20 kg body weight orally for 3–5 days.",
    literature: "ADE-MAX — Fat-soluble Vitamin Supplement",
  },
  {
    name: "ACLOWAN",
    generic: "Aceclofenac injection",
    division: "Livestock",
    mark: "A",
    form: "IM/IV injection",
    composition: "Aceclofenac 100 mg/mL",
    indications: "Analgesic, anti-inflammatory and antipyretic in large animals.",
    dosage: "1 mL per 25 kg body weight IM once daily for 3 days.",
    literature: "ACLOWAN — Veterinary NSAID",
  },
  {
    name: "ALBAWAN",
    generic: "Albendazole bolus",
    division: "Livestock",
    mark: "A",
    form: "Bolus",
    composition: "Albendazole 2500 mg per bolus",
    indications: "Broad-spectrum anthelmintic against GI nematodes and cestodes.",
    dosage: "One bolus per 250 kg body weight; repeat after 21 days.",
    literature: "ALBAWAN — Broad-spectrum Anthelmintic",
  },
  {
    name: "AMINOWAN",
    generic: "Amino acids & electrolytes",
    division: "Livestock",
    mark: "A",
    form: "Oral solution",
    composition: "Balanced blend of essential amino acids, electrolytes and dextrose",
    indications: "Metabolic stress, dehydration, post-illness recovery and heat stress.",
    dosage: "10–20 mL per 100 kg body weight in drinking water for 5–7 days.",
    literature: "AMINOWAN — Metabolic Support",
  },
  {
    name: "CEFUR-RTU",
    generic: "Ceftiofur injection",
    division: "Livestock",
    mark: "C",
    form: "Ready-to-use suspension",
    composition: "Ceftiofur hydrochloride 50 mg/mL",
    indications: "Bovine respiratory disease and interdigital necrobacillosis.",
    dosage: "1 mL per 50 kg body weight SC once daily for 3–5 days.",
    literature: "CEFUR-RTU — Veterinary Cephalosporin",
  },
  {
    name: "ENCURE-10",
    generic: "Enrofloxacin",
    division: "Livestock",
    mark: "E",
    form: "Oral / Injectable solution",
    composition: "Enrofloxacin 100 mg/mL",
    indications: "Systemic bacterial infections in cattle, sheep and goats.",
    dosage: "2.5–5 mg per kg body weight daily for 3–5 days.",
    literature: "ENCURE-10 — Fluoroquinolone Range",
  },
  {
    name: "GENTAWAN-10",
    generic: "Gentamicin",
    division: "Livestock",
    mark: "G",
    form: "Injection",
    composition: "Gentamicin sulphate 100 mg/mL",
    indications: "Gram-negative infections including E. coli and Salmonella.",
    dosage: "4 mg per kg body weight IM twice daily for 3 days.",
    literature: "GENTAWAN-10 — Aminoglycoside Antibiotic",
  },
  {
    name: "KETOWAN",
    generic: "Ketoprofen",
    division: "Livestock",
    mark: "K",
    form: "Injection",
    composition: "Ketoprofen 100 mg/mL",
    indications: "Pyrexia, colic, mastitis and musculoskeletal disorders.",
    dosage: "3 mg per kg body weight IM/IV once daily for 3 days.",
    literature: "KETOWAN — Injectable Analgesic",
  },
  {
    name: "NAWACIN",
    generic: "Oxytetracycline",
    division: "Livestock",
    mark: "N",
    form: "LA Injection",
    composition: "Oxytetracycline 200 mg/mL (long-acting)",
    indications: "Broad-spectrum antibacterial for respiratory and systemic infections.",
    dosage: "1 mL per 10 kg body weight IM every 72 hours.",
    literature: "NAWACIN — Long-acting Tetracycline",
  },
  {
    name: "WORMEC",
    generic: "Ivermectin",
    division: "Livestock",
    mark: "W",
    form: "Injectable solution",
    composition: "Ivermectin 10 mg/mL",
    indications: "Internal and external parasites in cattle, sheep and goats.",
    dosage: "1 mL per 50 kg body weight SC single dose.",
    literature: "WORMEC — Endectocide Reference",
  },
  {
    name: "ADEK EXCEL",
    generic: "Vitamins A, D3, E & K3",
    division: "Poultry",
    mark: "A",
    form: "Water-soluble powder",
    composition: "Vitamin A + D3 + E + K3 stabilised premix",
    indications: "Growth, egg production, hatchability and skeletal development.",
    dosage: "500 g per 1,000 L of drinking water for 3–5 days.",
    literature: "ADEK EXCEL — Vitamin Premix",
  },
  {
    name: "AMFUSTAT",
    generic: "Amprolium HCl",
    division: "Poultry",
    mark: "A",
    form: "Water-soluble powder",
    composition: "Amprolium HCl 200 mg/g",
    indications: "Prevention and treatment of coccidiosis in poultry.",
    dosage: "1.25 g per L drinking water for 5–7 days.",
    literature: "AMFUSTAT — Anticoccidial",
  },
  {
    name: "ASCOR-C",
    generic: "Ascorbic acid",
    division: "Poultry",
    mark: "A",
    form: "Water-soluble powder",
    composition: "Vitamin C 250 mg/g",
    indications: "Heat stress, disease recovery and improved feed conversion.",
    dosage: "1 g per L of drinking water for 3–5 days.",
    literature: "ASCOR-C — Anti-stress Support",
  },
  {
    name: "COCCIDAK",
    generic: "Diaveridine & vitamins",
    division: "Poultry",
    mark: "C",
    form: "Water-soluble powder",
    composition: "Diaveridine 40 mg + Sulphaquinoxaline 100 mg + Vitamins A & K3",
    indications: "Coccidiosis treatment with adjunctive vitamin support.",
    dosage: "1 g per 2 L of drinking water for 3 days.",
    literature: "COCCIDAK — Combination Anticoccidial",
  },
  {
    name: "COLIBAC",
    generic: "Colistin & Zinc Bacitracin",
    division: "Poultry",
    mark: "C",
    form: "Water-soluble powder",
    composition: "Colistin sulphate 2 MIU + Zinc Bacitracin 5 g per 100 g",
    indications: "Enteric infections and necrotic enteritis.",
    dosage: "1 g per L of drinking water for 5 days.",
    literature: "COLIBAC — Gut Health Antibiotic",
  },
  {
    name: "DOXIMAX",
    generic: "Doxycycline combination",
    division: "Poultry",
    mark: "D",
    form: "Water-soluble powder",
    composition: "Doxycycline HCl 100 mg + Tylosin tartrate 100 mg per g",
    indications: "Chronic respiratory disease (CRD) and mycoplasmosis.",
    dosage: "1 g per 2 L of drinking water for 3–5 days.",
    literature: "DOXIMAX — Respiratory Line",
  },
  {
    name: "ERTHYRO FZ",
    generic: "Erythromycin & Furazolidone",
    division: "Poultry",
    mark: "E",
    form: "Water-soluble powder",
    composition: "Erythromycin thiocyanate 5 g + Furazolidone 5 g per 100 g",
    indications: "CRD, fowl typhoid and enteric infections.",
    dosage: "1 g per 2 L of drinking water for 5 days.",
    literature: "ERTHYRO FZ — Macrolide Combination",
  },
  {
    name: "FLO-X",
    generic: "Florfenicol combination",
    division: "Poultry",
    mark: "F",
    form: "Oral solution",
    composition: "Florfenicol 100 mg/mL",
    indications: "Bacterial respiratory infections in broilers and breeders.",
    dosage: "1 mL per 2 L of drinking water for 3–5 days.",
    literature: "FLO-X — Broad-spectrum Amphenicol",
  },
  {
    name: "MULTINA",
    generic: "Vitamins & minerals",
    division: "Poultry",
    mark: "M",
    form: "Water-soluble powder",
    composition: "Multivitamin & trace mineral complex",
    indications: "General supplementation, stress and post-vaccination support.",
    dosage: "1 g per L of drinking water for 3 days.",
    literature: "MULTINA — Complete Supplement",
  },
  {
    name: "TOTRAX",
    generic: "Toltrazuril",
    division: "Poultry",
    mark: "T",
    form: "Oral suspension",
    composition: "Toltrazuril 25 mg/mL",
    indications: "Coccidiosis in chickens and turkeys.",
    dosage: "7 mg per kg body weight in drinking water for 2 days.",
    literature: "TOTRAX — Triazine Anticoccidial",
  },
  {
    name: "VIM-SEL",
    generic: "Vitamin E & Selenium",
    division: "Poultry",
    mark: "V",
    form: "Water-soluble powder",
    composition: "Vitamin E 50 mg + Sodium selenite 0.2 mg per g",
    indications: "Prevention of encephalomalacia and muscular dystrophy.",
    dosage: "1 g per 2 L of drinking water for 5 days.",
    literature: "VIM-SEL — Antioxidant Line",
  },
];

export const divisionFilters = ["All", "Human health", "Livestock", "Poultry"];
